import { useEffect, useState } from "react";
import { GRID_SEARCH_DEBOUNCE_MS } from "../Constants/gridDebounce";

/**
 * Returns a debounced copy of value (Pattern B search debounce).
 */
export default function useDebouncedValue(value, delay = GRID_SEARCH_DEBOUNCE_MS) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
